<template>
  <div :class="['form-group', {'has-danger': error, 'is-focused': value} ]">
    <label v-if="label">{{ label }}</label>
    <input v-if="!textArea" type="text" :value="value" @input="updateSelf($event.target.value)" class="form-control" :disabled="disabled" @change="change">
    <textarea v-if="textArea" style="height:115px" :value="value" @input="updateSelf($event.target.value)" class="form-control" :disabled="disabled" @change="change"></textarea>
    <!-- <input @blur="floatLabelBlur($event.target)"  @focus="floatLabelFocus($event.target)" :value="value" @input="updateSelf($event.target.value)" class="form-control" ref="input"> -->
    <label v-show="error" class="error">
      {{ error }}
    </label>
  </div>
</template>

<script>
export default {
   $_veeValidate: {
    name() {
      return this.label;
    },
    value() {
      return this.value;
    }
  },
  name: 'textinput',
  props: ['error','label', 'value','disabled','textArea'],
  methods: {
    updateSelf (value) {
      // console.log('input ' + value)
      this.$emit('input', value)
      this.change();
    },
    floatLabelFocus(e) {
      e.parentNode.classList.add('is-focused');
    },
    floatLabelBlur(e) {
      if(!this.value) {
        e.parentNode.classList.remove('is-focused');
      }
    },
    change() {
        // console.log('cambio')
        this.$emit('change')
    },
  }

}
</script>

<style scoped>
  .form-control {
    border: 1px solid #d0d3d8 !important;
    padding: 5px !important;
  }
</style>
